import { Fragment, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { __OPERATION__EVENT__ADMIN__ } from 'shell/constants/environment';
import Breadcrumbs from 'shell/components/shared/breadcrumb';
import { CommonEventRegistrationCrumbs } from '../constants';
import { toast } from 'react-toastify';
import { EventRegistrationForm } from 'system/components/event-registration/form';
import FormEventRegistration from 'system/components/event-registration/form';
import { useHttpClient } from 'shell/hooks/use-http-fetch/stateless';
import { transformEventRegistrationRequest } from '../utils/transform-event-registration-request';
import { AxiosPromise } from 'axios';

const EventSuscriberNewPage = (): React.ReactElement => {
  const navigate = useNavigate();

  const insertEventRegistration = useHttpClient(`${__OPERATION__EVENT__ADMIN__}/iscrizioneEvento`, {
    options: {
      errorCatching: true,
      method: 'POST',
      loading: true,
      data: {},
    },
  });

  const onSubmit = useCallback((formValues: EventRegistrationForm) => {
    const data = transformEventRegistrationRequest(formValues);
    (
      insertEventRegistration({
        data,
      }) as AxiosPromise<void>
    ).then(() => {
      toast.success('Operazione eseguita con successo');
      navigate('/sistema/eventmanager/iscrizione-evento');
    });
  }, []);

  return (
    <Fragment>
      <Breadcrumbs
        items={[...CommonEventRegistrationCrumbs, { name: 'Nuova Iscrizione Evento' }]}
      />
      <FormEventRegistration
        title="Nuova Iscrizione Evento"
        onOk={onSubmit}
        onCancel={() => {
          navigate('/sistema');
        }}
      />
    </Fragment>
  );
};

EventSuscriberNewPage.displayName = 'Event Subscriber new page component';

export default EventSuscriberNewPage;
